module.exports = __webpack_public_path__ + "static/media/vigipay.9c1e00cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/vigipay.png
// module id = 584
// module chunks = 0